import React from 'react';
import { Redirect } from 'react-router-dom';

import { FuseUtils } from '@fuse';

import { appsConfigs } from 'app/main/appsConfigs';
import { LoginConfig } from 'app/main/login/LoginConfig';
import { RegisterConfig } from 'app/main/register/RegisterConfig';
import { VerifyPageConfig } from 'app/main/pages/verify/VerifyPageConfig';
import { LandingPageConfig } from 'app/main/pages/landing/LandingPageConfig';
import { RecoverPasswordPageConfig } from 'app/main/pages/password-recover/RecoverPasswordPageConfig';
import { CoursesConfig } from '../main/courses/CoursesConfig';
import { HeidiLmsConfig } from '../main/heidi-lms/HeidiLmsConfig';
import { CampaignEmailLinkConfig } from '../main/login/CampaignEmailLinkConfig';
import { getDefaultRoute } from './util';

const routeConfigs = [
	...appsConfigs,
	LoginConfig,
	RegisterConfig,
	VerifyPageConfig,
	RecoverPasswordPageConfig,
	LandingPageConfig,
	CoursesConfig,
	HeidiLmsConfig,
	CampaignEmailLinkConfig
];

const routes = [
	...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['user']),
	{
		path: '/',
		component: () => {
			const route = getDefaultRoute();
			return <Redirect to={route} />
		}
	},
	{
		component: () => <Redirect to="/pages/errors/error-404" />
	}
];

export default routes;
